import { useEffect, useState } from 'react';
import { Typography } from '../../../molecules/Typography';
//import InnerHTMLContainer from "../../../molecules/InnerHTMLContainer";

interface IExerciseContent {
  text: string;
}

export function ExerciseContent({ text }: IExerciseContent) {
  const [stripedText, setStripedText] = useState<string>('');

  useEffect(() => {
    if (text) {
      const striped = stripHtmlTagsAdvanced(text);

      setStripedText(striped);
    }
  }, [text]);

  const stripHtmlTagsAdvanced = (html: string): string => {
    try {
      const elementoTemporario = document.createElement('div');
      elementoTemporario.innerHTML = html;

      return (
        elementoTemporario.textContent || elementoTemporario.innerText || ''
      );
    } catch (e: any) {
      return '';
    }
  };

  return (
    <div className='pr-4'>
      <Typography
        size='small'
        className='line-clamp-2 transition delay-100 ease-in-out group-hover:text-card-color-default'
      >
        {stripedText}
      </Typography>
    </div>
  );
}
